import React, { Fragment, useState } from 'react'
import DSIcon from './DSIcon'

const ContentDropDown = ({ title, description, pointers, pointerHeaders = [''], classes = '' }) => {
  const [flag, setFlag] = useState(false)

  return (
    <div className={'cursor-pointer border-b border-gray-200 pb-6 ' + classes} onClick={() => setFlag((flag) => !flag)}>
      <div className='flex justify-between items-center'>
        <h1 className='mb-0 mr-1 text-[15px] font-semibold text-gray-800'>{title}</h1>
        <span className={`inline-flex h-8 w-8 items-center justify-center rounded-ds-md border border-gray-300 bg-white text-gray-500 transition-transform duration-150 ${flag ? 'rotate-180' : ''}`}>
          <DSIcon name='chevron-down' size={16} />
        </span>
      </div>
      {flag && (
        <Fragment>
          <p className='mb-0 mt-3 mr-8 text-[13px] leading-6 text-gray-600'>{description}</p>
          {pointers &&
            pointerHeaders.map((item, ind) => (
              <Fragment>
                <p className='mb-0 mt-3 mr-8 text-[13px] font-semibold text-gray-700'>{item}</p>
                {pointers[ind].map((item) => (
                  <div className='mt-1 mr-8 flex text-[13px] leading-6 text-gray-600'>
                    <li className='mr-2'></li>
                    {item}
                  </div>
                ))}
              </Fragment>
            ))}
        </Fragment>
      )}
    </div>
  )
}

export default ContentDropDown
